// extracted by mini-css-extract-plugin
module.exports = {"parentContainerModal":"styles_parentContainerModal__3ZwQ0","tableList":"styles_tableList__2QLUx"};